module.exports = __webpack_public_path__ + "img/empty_search_2.7ea34ce2.png";